const isCalendlyEvent = (e) => e.data.event
  && e.data.event.indexOf('calendly') === 0;

function attachCallbackToCalendlyEventScheduled(callback) {
  async function listen(e) {
    if (isCalendlyEvent(e) && e.data.event === 'calendly.event_scheduled') {
      await callback();
      window.removeEventListener('message', listen, true);
    }
  }
  window.addEventListener('message', listen, true);
}

export default attachCallbackToCalendlyEventScheduled;
